export const ScheduleKConstants = {
    GracePeriodDays: 15,
    DefaultNotificationCodeValue: 'S',
    NumberOfMobilesTooltip: 'Not required for VHF or UHF.',
};
